import { render, staticRenderFns } from "./ProfileDropdownOrganisation.vue?vue&type=template&id=f889d270"
import script from "./ProfileDropdownOrganisation.vue?vue&type=script&lang=js"
export * from "./ProfileDropdownOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports